document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', id);
    });
  });


  document.querySelectorAll('form.haya-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const tagField = form.querySelector('input[name="contact[tags]"]');
      if (!tagField) return;

      const tags = ['newsletter', 'HAYA Waitlist'];
      const experience = form.querySelector('input[name="haya_experience"]:checked');
      if (experience) tags.push(`Experience: ${experience.value}`);

      form.querySelectorAll('input[name="haya_class_times"]:checked').forEach((input) => {
        tags.push(`Time: ${input.value}`);
      });

      tagField.value = tags.join(',');
    });
  });
  const success = document.querySelector('[data-waitlist-success]');
  if (success) {
    success.setAttribute('tabindex', '-1');
    success.focus({ preventScroll: true });
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});
